import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import _ from 'lodash'

import { Post, Get, Put } from 'utils/axios-token'
import { defaultFormVal } from './assets'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      selectedSetting: defaultFormVal,
      subscribedPackage: true
    }

    onChangeSettingHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getSelectedSetting = () => Get(
      `/api/v1/dialogues/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/email_settings`,
      payload => this.setState({ selectedSetting: payload }),
      () => {},
      this.load
    )

    updateSetting = (dataToSubmit) => {
      Put(
        `/api/v1/dialogues/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/email_settings`,
        dataToSubmit,
        () => this.updateSettingSuccess(),
        this.updateSettingError,
        this.load
      )
    }
    updateSettingSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }
    updateSettingError = error => this.requestError(error)

    createSetting = (dataToSubmit) => Post(
      `/api/v1/dialogues/centers/${this.props.data.selectCenterReducer.selectedCenter.center.id}/email_settings`,
      dataToSubmit,
      () => this.createSettingSuccess(),
      this.createSettingError,
      this.load
    )
    createSettingSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.getSelectedSetting()
    }
    createSettingError = error => this.requestError(error)
 
    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadSettingHOC={this.state.loading}

          getSelectedSetting={this.getSelectedSetting}
          createSetting={this.createSetting}
          updateSetting={this.updateSetting}
          onChangeSettingHOC={this.onChangeSettingHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC